import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentCategoryLookupComponent} from './document-category-lookup.component'
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [DocumentCategoryLookupComponent],
  exports: [DocumentCategoryLookupComponent]
})
export class DocumentCategoryLookupModule { }
